<template>
  <div class="footer">
    <div class="text">
      <p>
        <a href="https://beian.miit.gov.cn/#/Integrated/index">
          {{ FILING_NUMBER }}
        </a>
      </p>
    </div>
  </div>
</template>

<script>
import { FILING_NUMBER } from '@/utils/config.js'

export default {
  name: 'FooterIndex',
  data() {
    return {
      FILING_NUMBER
    }
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';
.footer {
  width: 100%;
  background-color: #272e36;
  padding: 10px 0;
  p {
    color: #fff;
    font-size: 14px;
    line-height: 32px;
    display: flex;
    text-align: center;
    align-items: center;
    justify-content: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/components/footer.vue